import { useState } from "react";
import { useNavigate } from "react-router-dom";
import YouTube from "react-youtube";
import { Button, Dimmer, Form, Loader } from "semantic-ui-react";
import MessageApiErrors from "../../components/MessageApiErrors";
import BarraDeProgresso from "../NovoPedido/components/BarraDeProgresso";
import logo from "../NovoPedido/logo-pt2.png";
import { instanceAxiosApiFiliado } from "../../dataProviders";
import useTempStorage, {
  KEY_COOKIE_HASH_PEDIDO,
} from "../../hooks/useTempStorage";

function RegistrarAtividade() {
  const [step, setStep] = useState(5);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [erro, setErro] = useState(null);
  const { cookie: hash } = useTempStorage(KEY_COOKIE_HASH_PEDIDO);

  const nextStep = () => {
    if (step >= 5) return;
    setStep(step + 1);
  };

  const registrarAtividadeHandler = () => {
    if (!hash) {
      return setErro("Não foi possível prosseguir. Tente novamente!");
    }

    setIsLoading(true);
    instanceAxiosApiFiliado
      .post(`/public/registrar-atividade/${hash}`)
      .then((res) => {
        navigate("/acompanhar-pedido");
      })
      .catch((e) => setErro(e))
      .then(() => setIsLoading(false));
  };

  return (
    <div>
      <div className="formFiliacao formCentral">
        <div className="logo">
          <img src={logo} alt="logo pt" />
        </div>
        <div className="fraseGuia">Bem vindo, bem vinda ao PT.</div>
        <BarraDeProgresso step={step} />
        <div className="formCampos">
          <Form>
            {erro && <MessageApiErrors erro={erro} />}
            <Dimmer active={isLoading} inverted>
              <Loader>Aguarde ...</Loader>
            </Dimmer>
            <p className="textoExplicativo">
              Antes de concluir seu pedido de filiação, assista esse vídeo e
              conheça um pouco sobre o Partido dos Trabalhadores.
            </p>
            <YouTube
              videoId="daNOjoNUBcU"
              opts={{
                height: "275",
                width: "640",
                playerVars: {
                  autoplay: 1,
                },
              }}
              title="Bem vindo, bem vinda ao PT."
              className="youtubePlayer"
            />
            <p></p>
            <Button className="buttonAcaoMetade" onClick={nextStep} secondary>
              Assistir depois
            </Button>
            <Button
              className="buttonAcaoMetade"
              onClick={registrarAtividadeHandler}
              primary
            >
              Eu já assisti
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default RegistrarAtividade;
